<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('userQuestionAnswers.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_user_question_answers')"
                :title="$addLabel('userQuestionAnswers.title')"
                @click="openUserQuestionAnswerModal()"
            />
        </app-page-top-section>

        <app-table
            id="user-question-answer-table"
            :options="options"
            @action="triggerActions"
        />

        <app-user-question-answer-modal
            v-if="isUserQuestionAnswerModalActive"
            v-model="isUserQuestionAnswerModalActive"
            :selected-url="selectedUrl"
            />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('user_question_answer-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import UserQuestionAnswerMixin from "../../../Mixins/Learning/UserQuestionAnswerMixin";

export default {
    name: "UserQuestionAnswer",
    mixins: [UserQuestionAnswerMixin],
    data() {
        return {
            userQuestionAnswer: '',
            userQuestionAnswersId: '',
            userQuestionAnswers: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            title: '',
            course_id: '',
            video_url: '',
            order: '',
            isUserQuestionAnswerModalActive: false,
            confirmationModalActive: false,
        }
    },
    created() {
        this.$store.dispatch( 'user_question_answer')
    },
    watch: {
        isUserQuestionAnswerModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openUserQuestionAnswerModal() {
            this.selectedUrl = '';
            this.isUserQuestionAnswerModalActive = true;
        },
        triggerActions(row, action, active) {
            this.userQuestionAnswersId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isUserQuestionAnswerModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
